import * as videojs from "video.js";

/**
 * Player banner class.
 */
export class PlayerBannerPlugin {

    private player: any;
    private domElement: any;
    private textContent: string;

    constructor(player, {text = 'Voir la vidéo complète en HD'} = {}) {

        this.player = player;
        this.textContent = text;

        this.setupDom();
        this.initEvents();
        return this;
    }

    private setupDom() {
        const domElement = (videojs as any).dom.createEl('div', {
            className: 'vjs-player-banner'
        });
        domElement.innerHTML = `<a href=''>${this.textContent}</a>`;
        this.player.el().appendChild(domElement);
        this.domElement = domElement;
    }

    private initEvents() {
        this.player.el().addEventListener('mouseenter', _ => this.onPlayerMouseEnter());
        this.player.el().addEventListener('mouseleave', _ => this.onPlayerMouseLeave());
        this.domElement.addEventListener('click', event => this.onClick(event));
    }

    private onClick(event) {
        event.preventDefault();
        this.player.trigger('clickBanner');
    }

    private onPlayerMouseEnter() {
        this.show();
    }

    private onPlayerMouseLeave() {
        this.hide();
    }

    private show() {
        this.domElement.style.opacity = '1';
    }

    private hide() {
        this.domElement.style.opacity = '0';
    }
}

const onPlayerReady = (player, options) => {
    player.playerBanner = new PlayerBannerPlugin(player, options);
};

const playerBanner = function (options: any) {
    this.ready(() => {
        onPlayerReady(this, options);
    });
};

export {playerBanner};